import { render, staticRenderFns } from "./OrderConsigneeContacts.vue?vue&type=template&id=923c18a0"
import script from "./OrderConsigneeContacts.vue?vue&type=script&lang=ts"
export * from "./OrderConsigneeContacts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports